/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 31/10/2022.
 */
import { FunnelBarChart } from '../charts/FunnelBarChart'
import { FunnelTimelineChart } from '../charts/FunnelTimelineChart'
/* import { StateTypeDonut } from './charts/StateTypeDonut'
import { Statistic } from 'antd'
import { ArrowUpOutlined } from '@ant-design/icons' */
import { FunnelCounts } from '../charts/FunnelCounts'
import { ScreenFailRate } from '../charts/ScreenFailRate'
import { RandoLine } from '../charts/RandoLine'
import { AdSpendLine } from '../charts/AdSpend'
import { PricePer } from '../charts/PricePer'
import { FacebookCampaignsTable } from '../charts/FacebookCampaignsTable'

export const GeneralStatsPage = () => {
  return (
    <>
      <div className="container" style={{ paddingBottom: 100 }}>
        <div className="row" style={{ marginBottom: 40, marginTop: 40 }}>
          <div className="col-12">
            <h3>Enrollment Funnel</h3>
          </div>
          <div className="col-8">
            <FunnelTimelineChart />
          </div>
          <div className="col-4">
            <FunnelBarChart />
          </div>
        </div>
        <div className="row" style={{ marginBottom: 40, marginTop: 40 }}>
          <div className="col-7">
            <FunnelCounts />
          </div>
          <div className="col-5">
            <div className="p-4 mb-4 chart">
              <ScreenFailRate />
            </div>
            <div className="p-4 mb-4 chart">
              <AdSpendLine />
              <RandoLine />
            </div>
            <div className="p-4 chart">
              <PricePer />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div>
              <FacebookCampaignsTable />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
